import { Stack } from "@mui/material";

import { type SupportShift } from "../types";
import { SupportShiftCard } from "./ShiftCard";

interface GuidedSupportShiftListProps {
  shifts: SupportShift[];
  onShiftSelect: (shiftId: string) => void;
}

/**
 * Renders a scrollable list of shift cards for the guided support flow.
 */
export function GuidedSupportShiftList(props: GuidedSupportShiftListProps) {
  const { shifts, onShiftSelect } = props;

  return (
    <Stack spacing={0}>
      {shifts.map((shift) => (
        <SupportShiftCard key={shift.id} shift={shift} onSelect={onShiftSelect} />
      ))}
    </Stack>
  );
}
